export interface AuthFlowState {
    nextAuthFlow: number;
    status: number;
    updatedAt?: string;
}

export enum AuthFlowStatus {
    Pending = 0,
    Ready = 1,
    Complete = 2,
    Invalid = 3,
    PermissionDenied = 4
}
